import { useFormik } from "formik";
import React from "react";

import { Button, Card, Form } from "react-bootstrap";
import { setDesignationMessage } from "redux/actions";


import { useAppDispatch } from "redux/store";
import { addDesignation, updateDesignation } from "services/designationService";
import { Constant } from "template/Constant";
import * as yup from 'yup';
type Props = {
    row?: any,
    hideShowForm: (actionName) => void;
    getData: (page, pageSize, searchKey) => void;
    action?: string
};
export const DesignationForm: React.FC<Props> = ({ row, hideShowForm, getData, action }) => {
    const dispatch = useAppDispatch();
    const iValue={designation_id:0,designation_name:'',is_active:''};
    const initialValue = action === 'edit' ? row : iValue;
    
    
    const formik = useFormik({
        initialValues: initialValue,
        onSubmit: async (values) => {
            if (action === 'edit') {
                const response = await updateDesignation(row.designation_id,values);
               if (response && (response.status === 200 || response.status === 201)) {
                    dispatch(setDesignationMessage("Updated Successfully"));
                    getData(Constant.defaultPageNumber, Constant.defaultPageSize, '');
                    hideShowForm('');
                } else {
                    dispatch(setDesignationMessage("Some error occured!"));
                }
            } else if (action === 'add') {
                const response = await addDesignation(values);
               if (response && (response.status === 200 || response.status === 201)) {
                    dispatch(setDesignationMessage("Added Successfully"));
                    getData(Constant.defaultPageNumber, Constant.defaultPageSize, '');
                    hideShowForm('');
                } else {
                    dispatch(setDesignationMessage("Some error occured!"));
                }
            }
        },
        validationSchema: yup.object({
           designation_name: yup.string().required('designation_name is required'),
is_active: yup.boolean().required('is_active is required'),

        }),
    });
    return (
        <Card className="shadow mb-4">
            <Card.Header className="py-3">
                <h6 className="m-0 font-weight-bold text-primary text-capitalize">{action} Designation
                    <Button className="btn-icon-split float-right" onClick={() => hideShowForm(false)}>
                        <span className="icon text-white-50">
                            <i className="fas fa-list"></i>
                        </span>
                        <span className="text">View Designation</span>
                    </Button>
                </h6>

            </Card.Header>
            <Card.Body>
                <Form onSubmit={formik.handleSubmit}>
                  <Form.Group>
<label className="form -control-label">designation_name</label>
<Form.Control type="text" name="designation_name" className="form-control" value={formik.values.designation_name}
onChange={formik.handleChange}
onBlur ={formik.handleBlur}
isInvalid ={!!formik.touched.designation_name && !!formik.errors.designation_name}
isValid ={!!formik.touched.designation_name && !formik.errors.designation_name}
></Form.Control>
{
    formik.errors.designation_name && (
    <Form.Control.Feedback type="invalid">
        <>{formik.errors.designation_name}</>
    </Form.Control.Feedback>
)}
</Form.Group>
<Form.Group>
<label className="form -control-label">is_active</label>
<Form.Control type="number" name="is_active" className="form-control" value={formik.values.is_active}
onChange={formik.handleChange}
onBlur ={formik.handleBlur}
isInvalid ={!!formik.touched.is_active && !!formik.errors.is_active}
isValid ={!!formik.touched.is_active && !formik.errors.is_active}
></Form.Control>
{
    formik.errors.is_active && (
    <Form.Control.Feedback type="invalid">
        <>{formik.errors.is_active}</>
    </Form.Control.Feedback>
)}
</Form.Group>

                    <Form.Group>
                        <Button type="submit" className="float-right" variant="primary">Save</Button>
                    </Form.Group>
                </Form>
            </Card.Body>
        </Card>
    );
}

